<label><input type="checkbox" [(ngModel)]="visibilityOptions.showUseAllowance">Use Allowance</label>
<label><input type="checkbox" [(ngModel)]="visibilityOptions.showUseLimit">Use Limit</label>
<label><input type="checkbox" [(ngModel)]="visibilityOptions.showParkingRequired">Parking Required</label>
